import {
    Button, Dialog, DialogActions, DialogContent, DialogTitle
} from '@mui/material';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useState } from 'react';
import BlockFormat from './BlockFormat';

const BlockDialog = ({ open, setOpen, rowLength, insertBlock }) => {
    const matches = useMediaQuery('(max-width:600px)');

    // longitud de columnas según el dispositivo
    const [xs, setXS] = useState(12);
    const [md, setMD] = useState(6);
    // fila en donde se insertará el bloque
    const [selectedRow, setSelectedRow] = useState(0);

    const handleClose = () => {
        setOpen(false);
    };

    return (
        <Dialog
            open={ open }
            onClose={ handleClose }
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            PaperProps={{ sx: { width: matches ? '100%' : '70%' } }}>
            <DialogTitle id="alert-dialog-title">
                Longitud de bloque
            </DialogTitle>
            <DialogContent>
                <BlockFormat
                    xs={xs}
                    setXS={setXS}
                    md={md}
                    setMD={setMD}
                    selectedRow={selectedRow}
                    setSelectedRow={setSelectedRow}
                    rowLength={rowLength}
                />
            </DialogContent>
            <DialogActions>
                <Button onClick={ handleClose }>Cancelar</Button>
                <Button onClick={ insertBlock(xs, md, selectedRow) } autoFocus>
                    Guardar
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default BlockDialog;